
/* injects from baggage-loader */

'use strict';

import { cardsQuestion, cards } from './page-seven.const.js';

import { shuffle, every } from 'lodash';

export default class PageSevenController {
    constructor($log, $state, $timeout, $interval, Session, Dialog) {
        'ngInject'; 
        this.$log = $log;  
        this.$state = $state;
        this.$timeout = $timeout;
        this.$interval = $interval;
        this.Session = Session;
        this.Dialog = Dialog;
        this.step = 0;
        this.page = 1;
        this.passPage = true;
        this.cardsQuestion = cardsQuestion;
        this.cards = cards;
    }

    $onInit(){   
        this.cardsAnswer = shuffle(cards);
        this.embedded = require('_images/page-seven/feedback.png');
        this.comoJogar = require('_images/page-seven/como_jogar.png');
    }

    nextPage(){
        this.step++;
        if(this.step>3)
            this.step = 0;
    }

    $onDestroy(){
        this.resetStage();
    }

    resetStage() {  
        for(let i = 0; i < this.cards.length; i++){
            this.cards[i].answered = false;
        }
    }

    onDropCard(e, data, index){
        if(data.icon === this.cards[index].icon){
            angular.element(e.target).removeClass("shake");
            this.cards[index].answered = true;
        }
        else{
            angular.element(e.target).removeClass("shake");
            this.$timeout(() => angular.element(e.target).addClass("shake"),100);
        }
        if(every(this.cardsAnswer, ['answered', true]))
            this.Dialog.showEmbedded(this.embedded, 0, this.redirectToStages.bind(this));
    }

    redirectToStages(){
        this.$state.go("page-eight");
    }

    openComoJogar(){
        this.Dialog.showEmbedded(this.comoJogar);
    }

    relerEntrevista(){
        this.Dialog.showInterview();
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/page-seven/page-seven.controller.js